module.exports = __webpack_public_path__ + "src/img/new.a1bc0aa4.svg";